import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, getCurrentInstance, onMounted, computed, ref } from 'vue';
  import { DiligenceExceptionStatusSource } from '@/Sources';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DiligenceExceptionStatusDropdownField',
  props: {
    value: { type: Number, required: false },
    label: { type: String, required: false, default: 'Internal Exception Status' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: $emits }: { emit: ({ (event: 'input', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number, label: string, disabled: boolean, autoAssign: boolean, placeholder?: string };

  const instance = getCurrentInstance();
  

  

  const source = ref(new DiligenceExceptionStatusSource());

  const onValueChanged = (evt: CustomEvent<number>) => {
    val.value = evt.detail;
  };

  const val = computed({
    get: () => props.value ?? '',
    set: (value: number) => $emits('input', value)
  });

  onMounted(() => {
    const dropdown = instance?.proxy.$el.querySelector('samc-dropdown-input') ?? null;
    if (dropdown !== null && dropdown.source === undefined) {
      dropdown.source = source.value as any;
    }
  });

return { __sfc: true,instance, props, $emits, source, onValueChanged, val }
}

})